/* eslint-disable ember/classic-decorator-hooks */
import * as FeedForwardStepResponse from '../../../step-response/feed-forward';
import Circuit from './circuit';
import BigHugeCircuitGroup from './big-huge-circuit-group';
import BaseMain from '../../implementation-common/base-main';
import * as ReverseImplementation from './reverse-implementation';

export default class MultipleFeedbackLowPassMain extends BaseMain {
  bigHugeCircuitGroupModel;
  reverseImplementation;
  algorithm;

  init() {
    this.bigHugeCircuitGroupModel = BigHugeCircuitGroup;
    this.reverseImplementation = ReverseImplementation;
  }

  getStepValues(idealStep, circuit, timeAxis) {
    var k = circuit.r5.value / circuit.r1.value;
    var result = FeedForwardStepResponse.getActualStepResponse(idealStep, circuit, timeAxis, k);
    result = result.map((item) => {
      return item * -1;
    });

    return result;
  }

  createCircuit(stageFp, gain, stageQ, optimization, initialCapacitorValue) {
    var result = Circuit.create({
      algorithm: this.algorithm,
      stageFp: stageFp,
      gain: gain,
      stageQ: stageQ,
      optimization: optimization,
      initialCapacitorValue: initialCapacitorValue,
    });
    return result;
  }
}
